import React from 'react'
import styled from 'styled-components'

import { Badge, Box, Flex } from 'pcln-design-system'

import ImageTileNav from './ImageTileNav'
import WebPBackgroundImage from './WebPBackgroundImage'

const ImageTileBackgroundImage = styled(WebPBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.isOpaque ? 0.7 : 0.9)};
  z-index: 0;
  transition: 0.2s ease-in-out;
`

const ImageTileFlex = styled(Flex)`
  height: ${(props) => props.height};
  position: relative;

  &:hover ${ImageTileBackgroundImage} {
    opacity: 0.9;
    cursor: ${(props) => (props.useLink ? 'auto' : 'pointer')};
  }
`

const StyledBadge = styled(Badge)`
  font-size: 10px;
  z-index: 1;
`

const PropsChildrenBox = styled(Box)`
  z-index: 1;
`

const ImageTile = ({
  imageWebP = '',
  image = '',
  height = '320px',
  title = '',
  titleColor = 'secondary',
  bold = true,
  caps = true,
  borderRadius,
  rounded,
  navArray = [],
  handleNavOnClick,
  useLink,
  isOpaque = true,
  ...props
}) => (
  <ImageTileFlex
    height={height}
    width={1}
    alignItems='center'
    flexDirection='column'
    justifyContent='center'
    color='background.darkest'
    borderRadius={borderRadius}
    rounded={rounded}
    useLink={useLink}
  >
    <ImageTileBackgroundImage
      imageWebP={imageWebP}
      image={image}
      height={height}
      bg='transparent'
      isOpaque={isOpaque}
      borderRadius={borderRadius}
      rounded={rounded}
    />
    {title.length > 0 && (
      <StyledBadge px={2} py='2px' color={titleColor} bold={bold} caps={caps} mb={2}>
        {title}
      </StyledBadge>
    )}
    {props.children && <PropsChildrenBox>{props.children}</PropsChildrenBox>}
    {navArray.length > 0 && (
      <ImageTileNav navArray={navArray} handleNavOnClick={handleNavOnClick} useLink={useLink} />
    )}
  </ImageTileFlex>
)

ImageTile.displayName = 'ImageTile'

export default ImageTile
